import React from "react";
import * as Styles from "./CalculatorError.styles";
import Text from "../styles/atoms/Text";
import Icon from "../styles/Icon";
import Button from "../styles/atoms/Button";
import { useUscLabel } from "../../../utils/labels";

const CalculatorError = (): JSX.Element => {
    const [injectionErrorTitle, injectionErrorDescription, injectionErrorButtonText] = useUscLabel([
        "uscCalculatorErrorTitle",
        "uscCalculatorErrorDescription",
        "uscCalculatorErrorButton",
    ]);

    return (
        <Styles.Content>
            <Styles.ErrorWrapper>
                <Styles.ErrorIcon>
                    <Icon variant="error" iconSize="large" />
                </Styles.ErrorIcon>
                <Text tag="h3" variant="h3">
                    {injectionErrorTitle}
                </Text>
                <Text
                    tag="p"
                    variant="paragraph-body-book"
                    spacing={{ mt: "spacing-3", mb: "spacing-3" }}
                    color="platinum-dark"
                >
                    {injectionErrorDescription}
                </Text>
                <Button variant="outline" onClick={() => window.location.reload()}>
                    {injectionErrorButtonText}
                </Button>
            </Styles.ErrorWrapper>
        </Styles.Content>
    );
};

export default CalculatorError;
